import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { NewSaleDialog } from "@/pages/Sales";
import { toast } from "sonner";

// Reuses the same customer/catalogue/price form as Sales. Each document gets
// a linked draft sale; there are no approval, allocation or commission changes.
export const CreateLinkedDocumentDialog = ({ kind, open, onOpenChange, onCreated }) => {
  const [options, setOptions] = useState(null);
  useEffect(() => {
    if (!open) return;
    let active = true;
    setOptions(null);
    Promise.all([
      api.get("/customers"),
      api.get("/catalogue/skus"),
      api.get("/catalogue/events"),
      api.get("/agencies"),
      api.get("/catalogue/offers"),
      api.get("/agencies/closers"),
    ]).then(([customers, skus, events, agencies, offers, closers]) => {
      if (active) setOptions({
        customers: customers.data, skus: skus.data, events: events.data,
        agencies: agencies.data, offers: offers.data,
        closers: (closers.data || []).filter((c) => c.active !== false),
      });
    }).catch((err) => {
      if (active) { toast.error(formatApiError(err.response?.data?.detail)); onOpenChange(false); }
    });
    return () => { active = false; };
  }, [open, onOpenChange]);
  if (!open) return null;
  return <NewSaleDialog
    open={open}
    onOpenChange={onOpenChange}
    documentType={kind}
    customers={options?.customers || []}
    skus={options?.skus || []}
    events={options?.events || []}
    agencies={options?.agencies || []}
    closers={options?.closers || []}
    offers={options?.offers || []}
    onStudentCreated={(student) => setOptions((prev) => prev
      ? { ...prev, customers: [student, ...prev.customers.filter((c) => c.id !== student.id)] }
      : prev)}
    optionsLoading={!options}
    onCreated={onCreated}
  />;
};
